<template>
  <div>
    <PageTitle :route="$route">
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <BankAccountForm v-if="bankaccount" :bankaccount="bankaccount" />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import BankAccountForm from '@/components/settings/test-registers/bankAccount/BankAccountForm.vue'

export default {
  name: 'BankAccount',
  components: {
    PageTitle,
    PageRowWrapper,
    BankAccountForm
  },
  computed: {
    ...mapState({
      bankaccount: state => state.bankaccount.bankAccountById
    })
  },
  methods: {
    ...mapActions('bankaccount', ['fetchById'])
  },
  mounted () {
    this.fetchById(this.$route.params.id)
  }

}

</script>
